import { Table } from '@app/modules/table/classes/table.class';
import { AuthService } from '@app/services';
import { Paginator } from '@app/classes';
import {
    NameColumn,
    JobTitleColumn,
    OfferExpirationColumn,
    StartDateColumn,
    OfferStatusColumn,
    OfferSentAtColumn,
    CosignerColumn,
} from './columns';
import { Candidate } from '@app/models/offer-letters/candidate.model';

export class CandidatesIndexTable extends Table {
    links = true;
    showMenuColumnOptions = false;

    constructor(protected auth: AuthService) {
        super(auth);
        this.boot();
    }

    getLink(candidate: Candidate): (string | number)[] {
        return ['/employees', 'offer-letters', 'candidates', String(candidate.id)];
    }

    setColumns(): void {
        this.columns = [
            new NameColumn(),
            new JobTitleColumn(),
            new CosignerColumn(),
            new OfferExpirationColumn(),
            new StartDateColumn(),
            new OfferStatusColumn(),
            new OfferSentAtColumn(),
        ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            Candidate.query().with(['latestOfferLetter.cosigners', 'latestOfferLetter.cosigners.employee'])
        );
    }
}
